import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}/log`

export const GetByText = async (token, text) => {
    

  const response = await axios.get(`${API_URL}/get_by_text/?text=${text}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};
